module.exports = __webpack_public_path__ + "img/google-play-appstore.c601ba0e.png";